import { render, staticRenderFns } from "./MPCardForm.vue?vue&type=template&id=632baa0e&scoped=true&"
import script from "./MPCardForm.vue?vue&type=script&lang=js&"
export * from "./MPCardForm.vue?vue&type=script&lang=js&"
import style0 from "./MPCardForm.vue?vue&type=style&index=0&id=632baa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632baa0e",
  null
  
)

export default component.exports